import { Meal } from "@/clients/models/Meal";
import { TextButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { getSafeAreaBottom } from "@/utils/safe-area-bottom";
import { memo, useState } from "react";
import { IngredientsModal } from "../ingredients-modal";
import { MethodModal } from "../method-modal";

interface MealDetailActionsProps {
  pageRef: React.RefObject<HTMLElement>;
  mealData: Meal;
  mealDay?: string;
  targetDate?: string;
  fromPlan?: boolean;
  onIngredientsClick?: () => void;
}

export const MealDetailActions = memo(function MealDetailActions({
  pageRef,
  mealData,
  mealDay,
  targetDate,
  fromPlan,
  onIngredientsClick,
}: MealDetailActionsProps) {
  const [isIngredientsModalOpen, setIsIngredientsModalOpen] = useState(false);
  const [isMethodModalOpen, setIsMethodModalOpen] = useState(false);
  const hasIngredients = mealData.ingredients.length > 0;
  const hasInstructions = mealData.instructions && mealData.instructions.length > 0;

  return (
    <div
      className={cn(
        "fixed bottom-0 left-1/2 z-50 flex w-max -translate-x-1/2 items-center justify-center rounded-[50px] bg-[rgba(24,29,39,0.9)] px-6 py-1 gap-1 whitespace-nowrap",
      )}
      style={{ marginBottom: getSafeAreaBottom() }}
    >
      {/* <div className="h-13 w-13" /> */}

      {hasIngredients && (
        <TextButton
          color="primary"
          onClick={onIngredientsClick ?? (() => setIsIngredientsModalOpen(true))}
          className={cn("h-11 w-fit px-2 py-3 text-[#fff] transition-all hover:opacity-80")}
          aria-label="View ingredients"
        >
          Ingredients
        </TextButton>
      )}

      {hasInstructions && (
        <TextButton
          color="primary"
          onClick={() => setIsMethodModalOpen(true)}
          className={cn("h-11 w-fit px-2 py-3 text-[#fff] transition-all hover:opacity-80")}
          aria-label="View cooking method"
        >
          Method
        </TextButton>
      )}

      <IngredientsModal
        pageRef={pageRef}
        isOpen={isIngredientsModalOpen}
        onDismiss={() => setIsIngredientsModalOpen(false)}
        meal={mealData}
        mealDay={mealDay}
        targetDate={targetDate}
        fromPlan={fromPlan}
      />

      <MethodModal
        pageRef={pageRef}
        isOpen={isMethodModalOpen}
        onDismiss={() => setIsMethodModalOpen(false)}
        meal={mealData}
      />
    </div>
  );
});
